(function () {
  'use strict';

  var selector = '[data-wb-lazy-third-party]';
  var mountedAttr = 'wbLazyMounted';
  var loadedScripts = Object.create(null);
  var observer = null;
  var fallbackDelay = 3000;

  function loadScript(src) {
    if (!src) return;
    if (loadedScripts[src]) return;
    loadedScripts[src] = true;

    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
  }

  function mount(target) {
    if (!target || target.dataset[mountedAttr] === 'true') return;
    target.dataset[mountedAttr] = 'true';

    loadScript(target.dataset.scriptSrc);

    if (!target.dataset.iframeSrc) return;

    var iframe = document.createElement('iframe');
    iframe.src = target.dataset.iframeSrc;
    iframe.loading = target.dataset.iframeLoading || 'lazy';
    iframe.frameBorder = '0';

    if (target.dataset.iframeId) iframe.id = target.dataset.iframeId;
    if (target.dataset.iframeClass) iframe.className = target.dataset.iframeClass;
    if (target.dataset.iframeTitle) iframe.title = target.dataset.iframeTitle;
    if (target.dataset.iframeLabel) iframe.setAttribute('aria-label', target.dataset.iframeLabel);
    else if (target.dataset.iframeTitle) iframe.setAttribute('aria-label', target.dataset.iframeTitle);

    target.appendChild(iframe);
  }

  function mountAll(targets) {
    for (var i = 0; i < targets.length; i += 1) mount(targets[i]);
  }

  function init() {
    var targets = document.querySelectorAll(selector);
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      window.setTimeout(function () { mountAll(targets); }, fallbackDelay);
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (!entries[i].isIntersecting) continue;
        mount(entries[i].target);
        observer.unobserve(entries[i].target);
      }
    }, { rootMargin: '500px 0px' });

    for (var j = 0; j < targets.length; j += 1) observer.observe(targets[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
